import { Box } from '@unifyapps/ui/components/Box';
import { clsx } from 'clsx';
import type { NavIconProps } from './NavigationIcon';
import { NavigationIcon } from './NavigationIcon';

type NavIconPairProps = Omit<NavIconProps, 'iconName' | 'Icon' | 'iconUrl'> & {
  iconName: string;
  activeIconName?: string;
};

/** renders default and active-state icons, toggling visibility based on isActive */
function NavIconPair({ iconName, activeIconName, isActive, ...sharedProps }: NavIconPairProps) {
  return (
    <>
      <Box className={clsx({ hidden: activeIconName && isActive })}>
        <NavigationIcon {...sharedProps} iconName={iconName} isActive={isActive} />
      </Box>
      {activeIconName ? (
        <Box className={clsx({ hidden: !isActive })}>
          <NavigationIcon {...sharedProps} iconName={activeIconName} isActive={isActive} />
        </Box>
      ) : null}
    </>
  );
}

export type { NavIconPairProps };
export { NavIconPair };
